export default "__VITE_ASSET__7c412fc3__"